import React from 'react';
import cn from 'classnames';
import styles from '../QuickShopModal.module.scss';
import ScriptLoader from '../util/ScriptLoader';
import processHtml from '../util/ScriptProcessor';
const CosTemplate = ({ QSProduct, articleId, }) => {
    const allScripts = processHtml(QSProduct);
    const firstBatch = [];
    const secondBatch = [];
    allScripts.forEach((script, index) => {
        if (index === 0) {
            firstBatch.push(script);
        }
        else {
            secondBatch.push(script);
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(ScriptLoader, { scripts: firstBatch, articleId: articleId, batchIdentifier: "scriptAbove" }),
        React.createElement("div", { id: QSProduct.querySelector('.o-quick-buy').id, className: cn('o-quick-buy', styles.QSProduct, styles.cos) },
            React.createElement("div", { className: cn(styles.productImage, styles.cos, 'product-image'), dangerouslySetInnerHTML: {
                    __html: QSProduct.querySelector(`.product-image`).innerHTML,
                } }),
            React.createElement("div", { className: cn(styles.productDetails, 'right-panel'), dangerouslySetInnerHTML: {
                    __html: QSProduct.querySelector('.right-panel').innerHTML,
                } })),
        React.createElement(ScriptLoader, { scripts: secondBatch, articleId: articleId, batchIdentifier: "scritpBelow" })));
};
export default CosTemplate;
//# sourceMappingURL=CosTemplate.js.map